export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getMyConsents({ rootGetters }, params) {
      return rootGetters.api.get('/user/my-consents', { params })
        .then((response) => response.data);
    },
    denyConsent({ rootGetters }, consentId) {
      return rootGetters.api.post('/consents/'+consentId+'/deny')
        .then((response) => response.data);
    },
    acceptConsent({ rootGetters }, consentId) {
      return rootGetters.api.post('/consents/'+consentId+'/accept')
        .then((response) => response.data);
    },
    rescindConsent({ rootGetters }, consentId) {
      return rootGetters.api.post('/consents/'+consentId+'/rescind')
        .then((response) => response.data);
    },
  },
};
